module.exports = __webpack_public_path__ + "img/bg.87bc1e87.png";